import axios from "axios";
import router from "../router";
import store from "../store";
import { PROVIDER_API_URL, GENERAL_API_URL } from "@/config/urls";

// **** CONSTS
const USER_TOKEN =
  store.getters["AuthenticationModule/getAuthenticatedUserData"].token;
const CURRENT_LANG = store.getters["AppLangModule/getAppLocale"] || "ar";

// Global headers
axios.defaults.baseURL = PROVIDER_API_URL;

axios.defaults.headers.common["cache-control"] = "no-cache";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Accept-Language"] = CURRENT_LANG;
axios.defaults.headers.common["Api-Version"] = "v1";
axios.defaults.headers.common["Api-Key"] =
  "eyJpdiI6IjF3cUZNaEs1NVh3RUZNdlVJTDk3Y2c9PSIsInZhbHVlIjoiQzlndGhNSUVZeTRVUmwvZnR3WGZuaDNaTUxObVZ6RXBNbmFITkRKWUtsTDFXUUIrQkkxMzkvWG9KTDc1K2Z0NiIsIm1hYyI6IjNkNWVlYWI5NjBmMGYxZWU5YzIzYWQzZjk1YjRjMDA3NWFhMDVkMmU3NmExM2ExYzBmM2ExYzNhNmEwOTU4N2IiLCJ0YWciOiIifQ==";

// Set Token If Exists
if (USER_TOKEN) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + USER_TOKEN;
}

// Add Request Interceptors
axios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    if (error.response.status === 403) {
      router.replace("/forbidden");
    }
    if (error.response.status === 401) {
      localStorage.removeItem("Tard_provider_dashboard_user_id");
      localStorage.removeItem("Tard_provider_dashboard_user_token");
      localStorage.removeItem("Tard_provider_dashboard_userName");
      router.replace("/");
    }
    return Promise.reject(error);
  }
);

// Add Response Interceptors
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 403) {
      router.replace("/forbidden");
    }
    if (error.response.status === 401) {
      localStorage.removeItem("Tard_provider_dashboard_user_id");
      localStorage.removeItem("Tard_provider_dashboard_user_token");
      localStorage.removeItem("Tard_provider_dashboard_userName");
      router.replace("/");
    }
    return Promise.reject(error);
  }
);

// Create a separate axios instance for general-api
export const generalAxios = axios.create({
  baseURL: GENERAL_API_URL,
  headers: {
    "cache-control": "no-cache",
    Accept: "application/json",
    "Accept-Language": CURRENT_LANG,
    "Api-Version": "v1",
    "Api-Key":
      "eyJpdiI6IjF3cUZNaEs1NVh3RUZNdlVJTDk3Y2c9PSIsInZhbHVlIjoiQzlndGhNSUVZeTRVUmwvZnR3WGZuaDNaTUxObVZ6RXBNbmFITkRKWUtsTDFXUUIrQkkxMzkvWG9KTDc1K2Z0NiIsIm1hYyI6IjNkNWVlYWI5NjBmMGYxZWU5YzIzYWQzZjk1YjRjMDA3NWFhMDVkMmU3NmExM2ExYzBmM2ExYzNhNmEwOTU4N2IiLCJ0YWciOiIifQ==",
  },
});

// Add Request Interceptors for generalAxios
generalAxios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    if (error.response && error.response.status === 403) {
      router.replace("/forbidden");
    }
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("Tard_provider_dashboard_user_id");
      localStorage.removeItem("Tard_provider_dashboard_user_token");
      localStorage.removeItem("Tard_provider_dashboard_userName");
      router.replace("/");
    }
    return Promise.reject(error);
  }
);

// Add Response Interceptors for generalAxios
generalAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 403) {
      router.replace("/forbidden");
    }
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("Tard_provider_dashboard_user_id");
      localStorage.removeItem("Tard_provider_dashboard_user_token");
      localStorage.removeItem("Tard_provider_dashboard_userName");
      router.replace("/");
    }
    return Promise.reject(error);
  }
);

export default axios;
